function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var MODE_LABELS = {
  off: 'Off',
  both: 'Both',
  server: 'Server',
  client: 'Client'
};
var escape = function escape(value) {
  return String(value !== null && value !== void 0 ? value : '').replace(/[&<>"']/g, function (_char) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[_char];
  });
};
module.exports = function (modules) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    dirty = _ref.dirty,
    saved = _ref.saved,
    error = _ref.error,
    filter = _ref.filter,
    _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? {} : _ref$filters;
  var present = (modules || []).filter(function (m) {
    return !m.missing;
  });
  var missing = (modules || []).filter(function (m) {
    return m.missing;
  });
  var select = function select(field, label, values) {
    var options = new Map();
    values.forEach(function (value) {
      return options.set(value.toLowerCase() || 'unspecified', value || 'Unspecified');
    });
    return "<label>".concat(label, "\n      <select class=\"admin-input\" data-module-filter=\"").concat(field, "\">\n        <option value=\"\">All</option>\n        ").concat(_toConsumableArray(options).sort(function (a, b) {
      return a[1].localeCompare(b[1]);
    }).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[0],
        text = _ref3[1];
      return "<option value=\"".concat(escape(value), "\" ").concat(filters[field] === value ? 'selected' : '', ">").concat(escape(text), "</option>");
    }).join(''), "\n      </select>\n    </label>");
  };
  var card = function card(m) {
    var missing_class = m.missing ? ' missing' : '';
    var title = m.name === 'admin' ? 'Admin stays available so you can keep using this page' : 'Click to change';
    return "\n      <button type=\"button\" class=\"admin-module-card mode-".concat(m.mode).concat(missing_class, "\" data-module=\"").concat(escape(m.name), "\" title=\"").concat(title, "\">\n        <span class=\"admin-module-name\">").concat(escape(m.name), "</span>\n        <span class=\"admin-module-mode\">").concat(MODE_LABELS[m.mode] || m.mode, "</span>\n        <span class=\"admin-module-thumbnail\" aria-hidden=\"true\">\n          ").concat(m.image ? "<img src=\"".concat(escape(m.image), "\" alt=\"\" loading=\"lazy\" />") : '', "\n        </span>\n      </button>\n    ");
  };
  return "\n    <div class=\"admin-modules-page\">\n      <div class=\"admin-modules-header\">\n        <h1>Modules</h1>\n        <button id=\"admin-modules-save\" class=\"admin-button\" ".concat(dirty ? '' : 'disabled', ">Save</button>\n      </div>\n\n      <p class=\"admin-modules-intro\">\n        Click a module to change how it runs on this server.\n        <strong>Off</strong> leaves it unused.\n        <strong>Both</strong> runs it on this server and includes it for browsers.\n        <strong>Server</strong> is this machine only.\n        <strong>Client</strong> is browsers only.\n      </p>\n\n      ").concat(error ? "<div class=\"admin-modules-error\">".concat(escape(error), "</div>") : '', "\n\n      ").concat(saved ? "<div class=\"admin-modules-saved\">\n              <strong>Configuration saved.</strong> The running server is not updated yet.\n              Stop Saito, run\n              <span class=\"admin-cmd-line\">\n                <b>npm run compile</b>\n                <button type=\"button\" class=\"admin-copy-cmd\" data-cmd=\"npm run compile\" title=\"Copy to clipboard\" aria-label=\"Copy to clipboard\"><i class=\"fa-solid fa-copy\"></i></button>\n              </span>\n              then start Saito again. Compile rebuilds the browser bundle; restart loads the new server modules.\n            </div>" : '', "\n\n      <div class=\"admin-modules-filters\">\n        <label class=\"admin-modules-search\">Search\n          <input type=\"search\" class=\"admin-input\" id=\"admin-modules-filter\"\n            placeholder=\"Search modules\" value=\"").concat(escape(filter), "\" />\n        </label>\n        ").concat(select('category', 'Category', modules.flatMap(function (m) {
    return m.categories || [];
  })), "\n        ").concat(select('status', 'Status', modules.map(function (m) {
    return m.status || '';
  })), "\n        ").concat(select('class', 'Class', modules.map(function (m) {
    return m["class"] || '';
  })), "\n        <label class=\"admin-modules-checkbox\">\n          <input type=\"checkbox\" data-module-filter=\"has_description\" ").concat(filters.has_description ? 'checked' : '', " />\n          has description\n        </label>\n        <label class=\"admin-modules-checkbox\">\n          <input type=\"checkbox\" data-module-filter=\"has_image\" ").concat(filters.has_image ? 'checked' : '', " />\n          has image\n        </label>\n      </div>\n      <p class=\"admin-modules-count\" role=\"status\"></p>\n      <p class=\"admin-modules-empty admin-modules-no-matches\" hidden>No modules match these filters.</p>\n\n      <div class=\"admin-modules-grid\">\n        ").concat(present.map(card).join(''), "\n      </div>\n\n      ").concat(missing.length ? "<div class=\"admin-modules-missing\">\n              <h2>In configuration, but not installed</h2>\n              <p>These modules are listed in the current configuration, but there is no matching directory in <code>mods/</code>.</p>\n              <div class=\"admin-modules-grid\">\n                ".concat(missing.map(card).join(''), "\n              </div>\n            </div>") : '', "\n    </div>\n  ");
};